import { createSlice } from '@reduxjs/toolkit';

const filterSlice = createSlice({
  name: 'filter',
  initialState: { items: [], tempItems: [],homepageData:{},eligibilityData:[],appointmentData:{},confirmappointment:{}},
  reducers: {
    setFilters: (state, action) => {
      state.items = action.payload;
    },
    setTemporaryFilters: (state, action) => {
      state.tempItems = action.payload;
    },
    setHomepageData: (state, action) => {
      state.homepageData = action.payload;
    },
    setEligibilityData: (state, action) => {
      state.eligibilityData = action.payload;
    },
    setAppointmentData: (state, action) => {
      state.appointmentData = action.payload;
    },
    confirmAppointmentData:(state,action)=>{
      state.confirmappointment=action.payload;
    },
  },
});

export const { setFilters, setTemporaryFilters,setHomepageData,setEligibilityData,setAppointmentData ,confirmAppointmentData} = filterSlice.actions;
export default filterSlice.reducer;
